module.exports = __webpack_public_path__ + "static/img/juan-wl-1.91d7312f.png";